import Button from 'common/components/Button'
import Flex from 'common/components/Flex'
import Image from 'common/components/Image'
import Typography from 'common/components/Typography'
import theme from 'common/theme'
import LocationIcon from 'services/LocalStorefront/assets/svg/location/location.svg'
import ProductIcon from 'services/LocalStorefront/assets/svg/product/product.svg'
import styled from 'styled-components'

const Card = styled.div`
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
`

const WrapperImage = styled.div`
  background-color: ${theme.colors.grayLight};
  height: 124px;
`
const WrapperIcon = styled.div`
  display: flex;
  width: 16px;
`

const Container = styled.div`
  padding: 20px;
  position: relative;
`
const StoreDescription = styled.div`
  flex-grow: 2;
`
const ButtonShowDetail = styled(Button)`
  height: 35px;
  border: 2px solid;
  white-space: nowrap;
`
interface CardProps {
  imageSrc: string
  name: string
  location: string
  productsNumber: number
  href: string
}

function StoreCard({
  imageSrc,
  name,
  location,
  productsNumber,
  href,
}: CardProps): JSX.Element {
  return (
    <Card data-testid="store-card">
      <WrapperImage>
        <Image
          src={imageSrc}
          alt={name}
          height="124px"
          objectFit="cover"
          radius="6px 6px 0 0"
          lazy
        />
      </WrapperImage>
      <Container>
        <Typography title={name} type="bh6" maxLine="1">
          {name}
        </Typography>
        <Flex margin="11px 0 0">
          <>
            <StoreDescription>
              <Flex alignItems="center">
                <>
                  <WrapperIcon>
                    <LocationIcon />
                  </WrapperIcon>
                  <Typography
                    type="rlabel"
                    marginLeft="16px"
                    color="mediumGrey"
                    maxLine="1"
                  >
                    {location}
                  </Typography>
                </>
              </Flex>
              <Flex margin="19px 0 0" alignItems="center">
                <>
                  <WrapperIcon>
                    <ProductIcon />
                  </WrapperIcon>
                  <Typography
                    type="rlabel"
                    marginLeft="16px"
                    color="mediumGrey"
                    maxLine="1"
                  >
                    {`${productsNumber} Produk`}
                  </Typography>
                </>
              </Flex>
            </StoreDescription>
            <Flex margin="0 0 0 15px" alignItems="center">
              <a href={href} target="_blank" rel="noreferrer">
                <ButtonShowDetail
                  variant="outlined"
                  color="primaryKonekto"
                  letterCase="capitalize"
                  padding="0 15px"
                >
                  Lihat Detail
                </ButtonShowDetail>
              </a>
            </Flex>
          </>
        </Flex>
      </Container>
    </Card>
  )
}

export default StoreCard
